import { render, staticRenderFns } from "./AnalysisTotalLossCard.vue?vue&type=template&id=0622436c"
import script from "./AnalysisTotalLossCard.vue?vue&type=script&lang=js"
export * from "./AnalysisTotalLossCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports